import fetch from "auth/FetchInterceptor";

const OneSignalService = {};

/**
 * Registra um usuário no OneSignal
 * @param {string} playerId - Player ID do OneSignal
 * @returns {Promise<Object>}
 */
OneSignalService.registerUser = async function (playerId) {
	return fetch({
		url: "/v1/rest/onesignal/registrar",
		method: "post",
		data: { playerId },
	});
};

/**
 * Remove o registro de um usuário no OneSignal
 * @returns {Promise<Object>}
 */
OneSignalService.unregisterUser = async function () {
	return fetch({
		url: "/v1/rest/onesignal/remover",
		method: "delete",
	});
};

/**
 * Remove um dispositivo específico do OneSignal
 * @param {string} playerId - Player ID do dispositivo
 * @returns {Promise<Object>}
 */
OneSignalService.removeDevice = async function (playerId) {
	return fetch({
		url: "/v1/rest/onesignal/remover-dispositivo",
		method: "delete",
		data: { playerId },
	});
};

export default OneSignalService;
